export default __webpack_public_path__ + "static/media/rule-processor.64cb56f1.png";